module.exports = __webpack_public_path__ + "static/img/9bg_12.aa91dc3.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/background/9bg_12.png
// module id = 773
// module chunks = 1